import React from 'react';
import AdminUserManagement from '../components/Admin/AdminUserManagement';

const AdminUserManagementPage = () => {
  return <AdminUserManagement />;
};

export default AdminUserManagementPage;